import type {
  Alert,
  Phone,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { ActionButton } from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"

import { ContactCard } from "./ContactCard"
import styles from "./Contacts.module.scss"
import type { TestFunctionality } from "./TestFunctionality"
import { usePhoneNumberModalContext } from "src/components"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.alerts.contacts."

interface Props {
  sugarmateAlert: Alert;
  hideAddButton?: boolean;
  testFunctionality?: TestFunctionality;
  phones: Phone[];
}

export function ActiveContacts(props: Props) {
  const {
    hideAddButton = false,
    testFunctionality,
    sugarmateAlert,
    phones,
  } = props

  const polyglot = usePolyglot()
  const { openPhoneNumberModal } = usePhoneNumberModalContext()

  const addPhoneNumber = useCallback(
    () => {
      openPhoneNumberModal()
    },
    [openPhoneNumberModal],
  )

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {polyglot.t(`${polyglotPrefix}active_heading`)}
      </div>
      {phones.length ? (
        phones.map((phone) => (
          <ContactCard
            key={phone.id}
            sugarmateAlert={sugarmateAlert}
            phone={phone}
            testFunctionality={testFunctionality}
          />
        ))
      ) : (
        <div className={styles.emptyMessage}>
          {polyglot.t(`${polyglotPrefix}empty_message`)}
        </div>
      )}
      {!hideAddButton && (
        <ActionButton
          stylePreset="secondary"
          className={styles.addButton}
          onClick={addPhoneNumber}
        >
          {polyglot.t(`${polyglotPrefix}add_cta`)}
        </ActionButton>
      )}
    </div>
  )
}
